// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.connections-title-container h3 {
    display: -webkit-box;
    overflow: hidden;
    max-height: 130px;
    margin-top: 15px;
    text-overflow: ellipsis;
    -webkit-line-clamp: 4;
    -webkit-box-orient: vertical;
}

.connections .account-status {
    font-family: 'connect-icons';
    speak: none;
    font-style: normal;
    font-weight: normal;
    font-variant: normal;
    text-transform: none;

    /* Better Font Rendering =========== */
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;

    /* Custom CSS to overwrite Bootstrap */
    background-image: none;
    display: inline-block;
    margin: 0 10px;
    position: relative;
}

.connections .account-status:after {
    width: 18px;
    height: 18px;
    line-height: 18px;
    border-radius: 50%;
    display: inline-block;
    text-align: center;
    content: '\\e019'; /* arrow icon */
    background: #e6e6e6;
    color: #fff;
    font-size: 10px;
    vertical-align: middle;
    margin-top: -2px;
}

.connections .social-account-list .social-account-entry:not(.active):hover .account-status:after {
    background: #50b012; /* green */
}

.connections .social-account-list .active .account-status:after, .connections .social-account-section .account-status:after, .connections .widget-takeover .account-status:after {
    content: '\\2714'; /* checkmark icon */
    background: #11a9ed; /* blue */
    color: #fff;
    font-size: 14px;
}

/*  ======================
      Connections Page
      ======================  */
/* right rail */

/* connections and followers tweaks */
.connections.page .grid-list .entry .span5, .connections-connections.page .grid-list .entry .span5, .connections.page .search-result .entry > .span3 {
    width: 88px; /* forcing fixed width on the avatar */
}

.connections.page .grid-list .entry, .connections-connections.page .grid-list .entry {
    min-height: 99px;
    margin-bottom: 30px;
}

.page.connections .search-result .entry {
    margin-bottom: 22px;
}

/*  ======================
      Connections List
      ======================  */
.connections-inline-list {
    width: 100%;
}
.connections-inline-list .connection {
    position: relative;
    margin-bottom: 5.5px;
    padding: 5.5px 22px 5.5px 5.5px;
}
.connections-inline-list .connection:nth-child(2n) {
    border-radius: 6px;
    background: #ededed;
}
.connections-inline-list .avatar {
    margin-right: 11px;
}
.connections-inline-list .avatar[data-noclip='true'], .connections-inline-list .avatar[src\$='-pmpr.png'], .connections-inline-list .avatar[src\$='-pmfr.png'], .connections-inline-list .avatar[src\$='-pmth.png'] {
    border-radius: 0 !important;
    clip-path: none;
}
.connections-inline-list .connection-name, .connections-inline-list .connection-name + .connection-username {
    display: inline-block;
    text-overflow: ellipsis;
    white-space: nowrap;
    overflow: hidden;
    vertical-align: middle;
}
.connections-inline-list .connection-name {
    max-width: 45%;
}
.connections-inline-list .connection-name + .connection-username {
    margin-left: 11px;
    max-width: 20%;
}
.connections-inline-list .connection-username {
    margin-right: 11px;
    color: #888;
    word-break: break-word;
    flex-grow: 1;
}
.connections-inline-list .connection-you .label, .connections-inline-list .btn, .connections-inline-list .connection-action-taken, .connections-inline-list .connection-type {
    position: absolute;
    top: 15px;
    right: 11px;
}
.connections-inline-list .btn-small, .connections-inline-list .connection-action-taken, .connections-inline-list .connection-type {
    min-width: 100px;
}
.connections-inline-list .connection-action-taken, .connections-inline-list .connection-type {
    /* mimics button styles, but action has been taken */
    padding: 3px 0;
    line-height: 16px;
    vertical-align: top;
    font-size: 11px;

    text-align: center;
    color: #555;
}
.connections-inline-list + p {
    margin-top: 22px;
}

/* Connect Checkbox */
.connections-inline-list .connect-checkbox {
    display: inline-block;
    float: right;
    margin-top: 10px;
    flex-shrink: 0;
}
.page.connections .search-result .social-account-section {
    padding-bottom: 15px; /*Usually 11px for a small, but since 4px is taken for the icon, this has been updated to 15px.*/
    border-bottom: 1px solid #ddd;
}

.page.connections .search-result .social-account-message {
    border: none;
}

.connections .search-result .social-account-status {
    margin: 0;
}

.page.connections .social-account-button {
    width: 14px;
    height: 14px;
    display: inline-block;
}

.page.connections .social-account-button.facebook {
    background: url(/modern/images/social-icons/facebook-sprite.png) 0 0/14px;
}

.page.connections .social-account-button.google {
    background: url(/modern/images/social-icons/google-sprite.png) 0 0/14px;
}

.page.connections .search-result .social-account-icon {
    width: 20px;
    height: 20px;
    display: inline-block;
}

.page.connections .social-account-icon.facebook {
    background: url(/modern/images/social-icons/facebook-sprite.png) 0 0/20px;
}

.page.connections .social-account-icon.google {
    background: url(/modern/images/social-icons/google-sprite.png) 0 0/20px;
}

.page.connections .social-icon-container {
    position: relative;
    line-height: 68px;
    width: 60px;
    height: 60px;
    margin-top: -4px;
    margin-right: 11px;
    text-align: center;
    border-radius: 50%;
    box-shadow: 0 0 0 2px #ccc;
}

.page.connections .social-icon-container .account-status {
    position: absolute;
    top: 42px;
    left: 30px;
}

/*  ======================
      Connections Modal
      ======================  */
.mutual-connections.modal .row {
    margin-left: 0;
}
.mutual-connections.modal .entry {
    padding-bottom: 20px;
}
.mutual-connections.modal .entry + .entry {
    padding-top: 20px;
}
.mutual-connections.modal .entry:not(:last-child) {
    border-bottom: 1px solid rgba(221, 221, 221, 0.3);
}
.mutual-connections.modal .modal-body .entry-content {
    word-wrap: break-word;
}

/* Search Icon For Connections Tab */
.page.connections .nav-tabs > li > a i.icon-search {
    padding: 1px 0 0 0;
}

.newsfeedLink {
    display: flex;
    justify-content: flex-end;
    margin-bottom: 10px;
}

.span4.newsfeedLink.desktop {
    display: flex; /* Override display block of span4 */
}

.newsfeedLink.mobile {
    display: none;
}

.newsfeedUnreadBubble {
    background: #1976d2;
    border-radius: 50%;
    z-index: 1;
    min-width: 6px;
    height: 6px;
    position: absolute;
    margin-left: 22px;
}

/* To align the width setting for [class*='span'] in _BootstrapB.scss */
@media (max-width: 1049px) {
    .newsfeedLink.mobile {
        display: flex;
    }

    .span4.newsfeedLink.desktop {
        display: none;
    }
}
`, "",{"version":3,"sources":["webpack://./src/styles/connections.page.module.css"],"names":[],"mappings":"AAAA;IACI,oBAAoB;IACpB,gBAAgB;IAChB,iBAAiB;IACjB,gBAAgB;IAChB,uBAAuB;IACvB,qBAAqB;IACrB,4BAA4B;AAChC;;AAEA;IACI,4BAA4B;IAC5B,WAAW;IACX,kBAAkB;IAClB,mBAAmB;IACnB,oBAAoB;IACpB,oBAAoB;;IAEpB,sCAAsC;IACtC,mCAAmC;IACnC,kCAAkC;;IAElC,sCAAsC;IACtC,sBAAsB;IACtB,qBAAqB;IACrB,cAAc;IACd,kBAAkB;AACtB;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,iBAAiB;IACjB,kBAAkB;IAClB,qBAAqB;IACrB,kBAAkB;IAClB,gBAAgB,EAAE,eAAe;IACjC,mBAAmB;IACnB,WAAW;IACX,eAAe;IACf,sBAAsB;IACtB,gBAAgB;AACpB;;AAEA;IACI,mBAAmB,EAAE,UAAU;AACnC;;AAEA;IAGI,gBAAgB,EAAE,mBAAmB;IACrC,mBAAmB,EAAE,SAAS;IAC9B,WAAW;IACX,eAAe;AACnB;;AAEA;;+BAE+B;AAC/B,eAAe;;AAEf,qCAAqC;AACrC;IAGI,WAAW,EAAE,sCAAsC;AACvD;;AAEA;IAEI,gBAAgB;IAChB,mBAAmB;AACvB;;AAEA;IACI,mBAAmB;AACvB;;AAEA;;+BAE+B;AAC/B;IACI,WAAW;AACf;AACA;IACI,kBAAkB;IAClB,oBAAoB;IACpB,+BAA+B;AACnC;AACA;IACI,kBAAkB;IAClB,mBAAmB;AACvB;AACA;IACI,kBAAkB;AACtB;AACA;IAII,2BAA2B;IAC3B,eAAe;AACnB;AACA;IAEI,qBAAqB;IACrB,uBAAuB;IACvB,mBAAmB;IACnB,gBAAgB;IAChB,sBAAsB;AAC1B;AACA;IACI,cAAc;AAClB;AACA;IACI,iBAAiB;IACjB,cAAc;AAClB;AACA;IACI,kBAAkB;IAClB,WAAW;IACX,sBAAsB;IACtB,YAAY;AAChB;AACA;IAII,kBAAkB;IAClB,SAAS;IACT,WAAW;AACf;AACA;IAGI,gBAAgB;AACpB;AACA;IAEI,oDAAoD;IACpD,cAAc;IACd,iBAAiB;IACjB,mBAAmB;IACnB,eAAe;;IAEf,kBAAkB;IAClB,WAAW;AACf;AACA;IACI,gBAAgB;AACpB;;AAEA,qBAAqB;AACrB;IACI,qBAAqB;IACrB,YAAY;IACZ,gBAAgB;IAChB,cAAc;AAClB;AACA;IACI,oBAAoB,EAAE,gGAAgG;IACtH,6BAA6B;AACjC;;AAEA;IACI,YAAY;AAChB;;AAEA;IACI,SAAS;AACb;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,qBAAqB;AACzB;;AAEA;IACI,yEAAyE;AAC7E;;AAEA;IACI,uEAAuE;AAC3E;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,qBAAqB;AACzB;;AAEA;IACI,yEAAyE;AAC7E;;AAEA;IACI,uEAAuE;AAC3E;;AAEA;IACI,kBAAkB;IAClB,iBAAiB;IACjB,WAAW;IACX,YAAY;IACZ,gBAAgB;IAChB,kBAAkB;IAClB,kBAAkB;IAClB,kBAAkB;IAClB,0BAA0B;AAC9B;;AAEA;IACI,kBAAkB;IAClB,SAAS;IACT,UAAU;AACd;;AAEA;;+BAE+B;AAC/B;IACI,cAAc;AAClB;AACA;IACI,oBAAoB;AACxB;AACA;IACI,iBAAiB;AACrB;AACA;IACI,iDAAiD;AACrD;AACA;IACI,qBAAqB;AACzB;;AAEA,oCAAoC;AACpC;IACI,kBAAkB;AACtB;;AAEA;IACI,aAAa;IACb,yBAAyB;IACzB,mBAAmB;AACvB;;AAEA;IACI,aAAa,EAAE,oCAAoC;AACvD;;AAEA;IACI,aAAa;AACjB;;AAEA;IACI,mBAAmB;IACnB,kBAAkB;IAClB,UAAU;IACV,cAAc;IACd,WAAW;IACX,kBAAkB;IAClB,iBAAiB;AACrB;;AAEA,uEAAuE;AACvE;IACI;QACI,aAAa;IACjB;;IAEA;QACI,aAAa;IACjB;AACJ","sourcesContent":[":global .connections-title-container h3 {\n    display: -webkit-box;\n    overflow: hidden;\n    max-height: 130px;\n    margin-top: 15px;\n    text-overflow: ellipsis;\n    -webkit-line-clamp: 4;\n    -webkit-box-orient: vertical;\n}\n\n:global .connections .account-status {\n    font-family: 'connect-icons';\n    speak: none;\n    font-style: normal;\n    font-weight: normal;\n    font-variant: normal;\n    text-transform: none;\n\n    /* Better Font Rendering =========== */\n    -webkit-font-smoothing: antialiased;\n    -moz-osx-font-smoothing: grayscale;\n\n    /* Custom CSS to overwrite Bootstrap */\n    background-image: none;\n    display: inline-block;\n    margin: 0 10px;\n    position: relative;\n}\n\n:global .connections .account-status:after {\n    width: 18px;\n    height: 18px;\n    line-height: 18px;\n    border-radius: 50%;\n    display: inline-block;\n    text-align: center;\n    content: '\\e019'; /* arrow icon */\n    background: #e6e6e6;\n    color: #fff;\n    font-size: 10px;\n    vertical-align: middle;\n    margin-top: -2px;\n}\n\n:global .connections .social-account-list .social-account-entry:not(.active):hover .account-status:after {\n    background: #50b012; /* green */\n}\n\n:global .connections .social-account-list .active .account-status:after,\n:global .connections .social-account-section .account-status:after,\n:global .connections .widget-takeover .account-status:after {\n    content: '\\2714'; /* checkmark icon */\n    background: #11a9ed; /* blue */\n    color: #fff;\n    font-size: 14px;\n}\n\n/*  ======================\n      Connections Page\n      ======================  */\n/* right rail */\n\n/* connections and followers tweaks */\n:global .connections.page .grid-list .entry .span5,\n:global .connections-connections.page .grid-list .entry .span5,\n:global .connections.page .search-result .entry > .span3 {\n    width: 88px; /* forcing fixed width on the avatar */\n}\n\n:global .connections.page .grid-list .entry,\n:global .connections-connections.page .grid-list .entry {\n    min-height: 99px;\n    margin-bottom: 30px;\n}\n\n:global .page.connections .search-result .entry {\n    margin-bottom: 22px;\n}\n\n/*  ======================\n      Connections List\n      ======================  */\n:global .connections-inline-list {\n    width: 100%;\n}\n:global .connections-inline-list .connection {\n    position: relative;\n    margin-bottom: 5.5px;\n    padding: 5.5px 22px 5.5px 5.5px;\n}\n:global .connections-inline-list .connection:nth-child(2n) {\n    border-radius: 6px;\n    background: #ededed;\n}\n:global .connections-inline-list .avatar {\n    margin-right: 11px;\n}\n:global .connections-inline-list .avatar[data-noclip='true'],\n:global .connections-inline-list .avatar[src$='-pmpr.png'],\n:global .connections-inline-list .avatar[src$='-pmfr.png'],\n:global .connections-inline-list .avatar[src$='-pmth.png'] {\n    border-radius: 0 !important;\n    clip-path: none;\n}\n:global .connections-inline-list .connection-name,\n:global .connections-inline-list .connection-name + .connection-username {\n    display: inline-block;\n    text-overflow: ellipsis;\n    white-space: nowrap;\n    overflow: hidden;\n    vertical-align: middle;\n}\n:global .connections-inline-list .connection-name {\n    max-width: 45%;\n}\n:global .connections-inline-list .connection-name + .connection-username {\n    margin-left: 11px;\n    max-width: 20%;\n}\n:global .connections-inline-list .connection-username {\n    margin-right: 11px;\n    color: #888;\n    word-break: break-word;\n    flex-grow: 1;\n}\n:global .connections-inline-list .connection-you .label,\n:global .connections-inline-list .btn,\n:global .connections-inline-list .connection-action-taken,\n:global .connections-inline-list .connection-type {\n    position: absolute;\n    top: 15px;\n    right: 11px;\n}\n:global .connections-inline-list .btn-small,\n:global .connections-inline-list .connection-action-taken,\n:global .connections-inline-list .connection-type {\n    min-width: 100px;\n}\n:global .connections-inline-list .connection-action-taken,\n:global .connections-inline-list .connection-type {\n    /* mimics button styles, but action has been taken */\n    padding: 3px 0;\n    line-height: 16px;\n    vertical-align: top;\n    font-size: 11px;\n\n    text-align: center;\n    color: #555;\n}\n:global .connections-inline-list + p {\n    margin-top: 22px;\n}\n\n/* Connect Checkbox */\n:global .connections-inline-list .connect-checkbox {\n    display: inline-block;\n    float: right;\n    margin-top: 10px;\n    flex-shrink: 0;\n}\n:global .page.connections .search-result .social-account-section {\n    padding-bottom: 15px; /*Usually 11px for a small, but since 4px is taken for the icon, this has been updated to 15px.*/\n    border-bottom: 1px solid #ddd;\n}\n\n:global .page.connections .search-result .social-account-message {\n    border: none;\n}\n\n:global .connections .search-result .social-account-status {\n    margin: 0;\n}\n\n:global .page.connections .social-account-button {\n    width: 14px;\n    height: 14px;\n    display: inline-block;\n}\n\n:global .page.connections .social-account-button.facebook {\n    background: url(/modern/images/social-icons/facebook-sprite.png) 0 0/14px;\n}\n\n:global .page.connections .social-account-button.google {\n    background: url(/modern/images/social-icons/google-sprite.png) 0 0/14px;\n}\n\n:global .page.connections .search-result .social-account-icon {\n    width: 20px;\n    height: 20px;\n    display: inline-block;\n}\n\n:global .page.connections .social-account-icon.facebook {\n    background: url(/modern/images/social-icons/facebook-sprite.png) 0 0/20px;\n}\n\n:global .page.connections .social-account-icon.google {\n    background: url(/modern/images/social-icons/google-sprite.png) 0 0/20px;\n}\n\n:global .page.connections .social-icon-container {\n    position: relative;\n    line-height: 68px;\n    width: 60px;\n    height: 60px;\n    margin-top: -4px;\n    margin-right: 11px;\n    text-align: center;\n    border-radius: 50%;\n    box-shadow: 0 0 0 2px #ccc;\n}\n\n:global .page.connections .social-icon-container .account-status {\n    position: absolute;\n    top: 42px;\n    left: 30px;\n}\n\n/*  ======================\n      Connections Modal\n      ======================  */\n:global .mutual-connections.modal .row {\n    margin-left: 0;\n}\n:global .mutual-connections.modal .entry {\n    padding-bottom: 20px;\n}\n:global .mutual-connections.modal .entry + .entry {\n    padding-top: 20px;\n}\n:global .mutual-connections.modal .entry:not(:last-child) {\n    border-bottom: 1px solid rgba(221, 221, 221, 0.3);\n}\n:global .mutual-connections.modal .modal-body .entry-content {\n    word-wrap: break-word;\n}\n\n/* Search Icon For Connections Tab */\n:global .page.connections .nav-tabs > li > a i.icon-search {\n    padding: 1px 0 0 0;\n}\n\n:global .newsfeedLink {\n    display: flex;\n    justify-content: flex-end;\n    margin-bottom: 10px;\n}\n\n:global .span4.newsfeedLink.desktop {\n    display: flex; /* Override display block of span4 */\n}\n\n:global .newsfeedLink.mobile {\n    display: none;\n}\n\n:global .newsfeedUnreadBubble {\n    background: #1976d2;\n    border-radius: 50%;\n    z-index: 1;\n    min-width: 6px;\n    height: 6px;\n    position: absolute;\n    margin-left: 22px;\n}\n\n/* To align the width setting for [class*='span'] in _BootstrapB.scss */\n@media (max-width: 1049px) {\n    :global .newsfeedLink.mobile {\n        display: flex;\n    }\n\n    :global .span4.newsfeedLink.desktop {\n        display: none;\n    }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"connections-title-container": `connections-title-container`,
	"connections": `connections`,
	"account-status": `account-status`,
	"social-account-list": `social-account-list`,
	"social-account-entry": `social-account-entry`,
	"active": `active`,
	"social-account-section": `social-account-section`,
	"widget-takeover": `widget-takeover`,
	"page": `page`,
	"grid-list": `grid-list`,
	"entry": `entry`,
	"span5": `span5`,
	"connections-connections": `connections-connections`,
	"search-result": `search-result`,
	"span3": `span3`,
	"connections-inline-list": `connections-inline-list`,
	"connection": `connection`,
	"avatar": `avatar`,
	"connection-name": `connection-name`,
	"connection-username": `connection-username`,
	"connection-you": `connection-you`,
	"label": `label`,
	"btn": `btn`,
	"connection-action-taken": `connection-action-taken`,
	"connection-type": `connection-type`,
	"btn-small": `btn-small`,
	"connect-checkbox": `connect-checkbox`,
	"social-account-message": `social-account-message`,
	"social-account-status": `social-account-status`,
	"social-account-button": `social-account-button`,
	"facebook": `facebook`,
	"google": `google`,
	"social-account-icon": `social-account-icon`,
	"social-icon-container": `social-icon-container`,
	"mutual-connections": `mutual-connections`,
	"modal": `modal`,
	"row": `row`,
	"modal-body": `modal-body`,
	"entry-content": `entry-content`,
	"nav-tabs": `nav-tabs`,
	"icon-search": `icon-search`,
	"newsfeedLink": `newsfeedLink`,
	"span4": `span4`,
	"desktop": `desktop`,
	"mobile": `mobile`,
	"newsfeedUnreadBubble": `newsfeedUnreadBubble`
};
export default ___CSS_LOADER_EXPORT___;
